import HeaderV1 from './HeaderV1';
import type { HeaderV1Props } from './HeaderV1';
import HeaderV2, { HeaderV2Props } from './HeaderV2';

export type HeaderWrapperProps = {
  /** Currently, v2 is used only on some pages */
  v2?: boolean;
} & (HeaderV1Props | HeaderV2Props);

const HeaderWrapper = ({ v2, ...props }: HeaderWrapperProps) => {
  return v2 ? (
    <HeaderV2 {...(props as HeaderV2Props)} />
  ) : (
    <HeaderV1 {...(props as HeaderV1Props)} />
  );
};

export default HeaderWrapper;
